export default "__VITE_ASSET__Bn3sTw4F__"